"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var Item_1 = __importDefault(require("./Item/Item"));
var FilterPanel_1 = __importDefault(require("./FilterPanel/FilterPanel"));
/**
 * @child ./Item/Item.tsx
 * @child ./FilterPanel/FilterPanel.tsx
 */
var HeaderBar = /** @class */ (function (_super) {
    __extends(HeaderBar, _super);
    function HeaderBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderBar.prototype.render = function () {
        return (React.createElement("div", { className: "menu-items" }, this.props.children));
    };
    HeaderBar.Item = Item_1.default;
    HeaderBar.FilterPanel = FilterPanel_1.default;
    return HeaderBar;
}(react_1.Component));
exports.default = HeaderBar;
//# sourceMappingURL=HeaderBar.js.map